<section
  class="rounded-4xl relative mx-auto w-11/12 max-w-[560px] bg-white px-10 pb-10 pt-12 text-blue-900"
  data-testid="leave-page-dialog-root"
>
  <i
    (click)="close(false)"
    class="g-filter-gray-800 absolute right-4 top-4 h-8 w-8 cursor-pointer"
    [style.background-image]="'url(' + iconPath + '/x-32.svg)'"
    data-testid="close-dialog"
  ></i>
  <h4 class="text-center text-xl font-bold">Leave this Page?</h4>
  <p class="mb-8 mt-4">Changes that you made won’t be saved. If you leave this page all the progress will be lost.</p>
  <div class="flex justify-center gap-4">
    <button cslButton="secondary" class="w-44" (click)="close(false)" data-testid="close-button">Cancel</button>
    <button cslButton class="w-44" (click)="close(true)" data-testid="confirm-button">Leave</button>
  </div>
</section>
